import { chain, keyBy } from "lodash"
import { buildContributorKey } from "helpers/contributors"

export function computeFactorSensitivityContributors(factorSensitivityContributors) {
  return chain(factorSensitivityContributors)
    .keyBy(buildContributorKey)
    .mapValues(contributor => ({
      factors: keyBy(contributor.factors, "id"),
      ...(contributor.contributors && { contributors: computeFactorSensitivityContributors(contributor.contributors) }),
    }))
    .value()
}
